import { jsx as _jsx } from "react/jsx-runtime";
import { BackgroudAppContext } from '../../iframe/useBackgroundApp';
import { useGetEmbedder } from '../../utils/useGetEmbedder';
import LoadingBlock from './LoadingBlock';
export default function EmbedderContainer({ children, }) {
    const { embedder, errorElement, isLoading } = useGetEmbedder();
    if (errorElement) {
        return errorElement;
    }
    if (isLoading) {
        return _jsx(LoadingBlock, {});
    }
    return (_jsx(BackgroudAppContext.Provider, { value: embedder, children: children }));
}
